import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import uploadImage from "../../assests/images/Upload icon.png";
import Switch from "@mui/material/Switch";
import { UserObj } from "../../services/localStarage";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import Stack from "@mui/material/Stack";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import topArrow from '../../assests/images/top.png';
import topHighlightArrow from '../../assests/images/top-highlighted.png';
import bottomArrow from '../../assests/images/bottom.png';
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import bottomHighlightArrow from '../../assests/images/bottom-highlighted.png';
import { Link, useLocation, useNavigate } from "react-router-dom";
import { purchaseOrderServices } from "../../services/purchaseOrderServices";
import { isEmptyDash, returnRateVal, strToDate, strToDateYYMMDD } from "../../constant";
import _ from "lodash";
import AlertComponent from "../alert/alert";
import { Backdrop, CircularProgress } from "@mui/material";
import { onboardingServices } from "../../services/onboardingServices";
import PackageDocuments from "../projectManagerScreens/packageDocuments";
import { qcServices } from "../../services/qcServices";
import Tooltip from '@mui/material/Tooltip';
import {trimString } from "../../constant";

const initialColumns = [
  { id: "productNumber", label: "Product ID", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "description", label: "Product Name", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  // { id: "batchno.", label: "Batch No.", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  // { id: "pcs/boxid", label: "PCS/Box ID", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "totalQuantity", label: "Total Quantity", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "deliveredQty", label: "Deliver Quantity", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "pendingQty", label: "Pending Quantity", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "netPrice", label: "Rate", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "RATE" },
  { id: "netValue", label: "Total Value", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "RATE" },
];
const shipmentdetailColumns = [
  { id: "productNumber", label: "Product ID", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "description", label: "Product Name", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "balanceQty", label: "Balance Quantity", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "inputQty", label: "QC Quantity", isSort: true, sortLabel: "", isSearchInput: false, isManadatory: true, value: "", formate: "INPUT_TEXT", type: "text" },
  { id: " ", label: "Action", isSort: false, sortLabel: "", isSearchInput: false, inputText: "", formate: "DELETE" },
];


const productListInit = {
  totalPages: 0,
  currentPage: 1,
  totalItems: 0,
  products: [],
}

const requestPayloadInitials = {
  pageNumber: 1,
  pageSize: 10,
  sortArray: [],
  searchCriteria: [],
};

function QcCreationForm() {

  const [dragging, setDragging] = useState(false);
  const userRole = UserObj ? UserObj?.role?.name : "";

  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });

  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertComponent({ ...alertComponent, open: false });
  };

  const [isLoading, setIsLoading] = useState(false);

  const [files, setFiles] = useState([]);
  const [poProductsListing, setPOProductsListing] = React.useState(productListInit);
  const label = { inputProps: { "aria-label": "Switch demo" } };
  const [selectedPO, setSelectedPO] = useState("");
  const [requestPayloadProduct, setRequestPayloadProduct] = useState(requestPayloadInitials);
  const [filterText, setFilterText] = useState("");
  const [selectedPOArr, setSelectedPOArr] = useState([]);
  const [selectedDeletedArr, setSelectedDeletedArr] = useState([]);
  const [filterFormData, setFilterFormData] = useState("");
  const [mdccDetails, setMdccDetails] = useState({
    "mdccNumber": "",
    "dateOfInspection": "",
    "mdccIssueDate": "",
    "remarks": "",
    "mdcc": [],
  });

  const [isMediaListModalOpen, setIsMediaListModalOpen] = useState(false);
  const [uploadFilesObj, setUploadFilesObj] = useState({});

  const [columns, setColumns] = useState(initialColumns);
  const [columnshipment, setColumnshipment] = useState(shipmentdetailColumns);
  const qcListing = {
    currentPage: 1,
    totalPages: 20,
  }
  const [inputPage, setInputPage] = useState(qcListing?.currentPage || 1);

  useEffect(() => {
    if (!isEmptyDash(selectedPO)) {
      getPOProductsListing(requestPayloadProduct, filterText, filterFormData, selectedPO);
    }
  }, [requestPayloadProduct, selectedPO]);

  const handleInputChange = (event) => {
    const value = event.target.value;
    if (value === '' || /^[0-9]+$/.test(value)) {
      setInputPage(value);
    }
  };

  const handleInputSubmit = (event) => {
    if (event.key === 'Enter') {
      const page = parseInt(inputPage, 10);
      if (!isNaN(page) && page > 0 && page <= qcListing?.totalPages) {
        onPaginationChange(event, page);
      } else {
        setInputPage(qcListing?.currentPage);
      }
    }
  };

  useEffect(() => {
    setChecked(false);

    const url = window.location.href;
    const urlObj = new URL(url);
    const params = urlObj.searchParams;
    const POCodeParam = params.get('poId');
    const QCCodeParam = params.get('qcId');
    if (!isEmptyDash(POCodeParam)) {
      setSelectedPO(POCodeParam);
    }
    if (!isEmptyDash(QCCodeParam)) {
      getDetails(QCCodeParam);
      getProductsListing(QCCodeParam);
    }
  }, []);

  let navigate = useNavigate();
  const navigateUrl = (param) => {
    navigate(param);
  };


  const getDetails = (param) => {
    setIsLoading(true);
    let url = `/${param}`;
    let promise = qcServices.getQCListing(url);
    promise.then((res) => {
      if (res.data.success === true) {
        let obj = {
          "mdccNumber": res.data?.data?.mdccNumber,
          "dateOfInspection": strToDateYYMMDD(res.data?.data?.dateOfInspection),
          "mdccIssueDate": strToDateYYMMDD(res.data?.data?.mdccIssueDate),
          "remarks": res.data?.data?.remarks,
          "mdcc": res.data?.data?.mdcc,
          "qcNumber": res.data?.data?.qcNumber,
          "_id": res.data?.data?._id,
        }
        setMdccDetails(obj);
      } else {
        setAlertComponent({ open: true, type: "error", message: `No Data Found ` });
      }
    })
      .catch(function (error) {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  }

  const getProductsListing = (id, requestPayloadParam) => {
    setIsLoading(true);
    let param = `?page=1&pageSize=100`;
    // if (requestPayloadParam.sortArray.length > 0) {
    //   param += `&sortBy=${requestPayloadParam.sortArray[0]}&sortOrder=${requestPayloadParam.sortArray[1]}`;
    // }
    // const filteredFormData = formData ? Object.entries(formData)
    //   .filter(([key, value]) => value !== '')
    //   .reduce((acc, [key, value]) => {
    //     acc[key] = value;
    //     return acc;
    //   }, {}) : {};
    // if (filteredFormData && Object.keys(filteredFormData).length > 0) {
    //   Object.entries(filteredFormData).forEach(([key, value]) => {
    //     param += `&${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
    //   });
    // }

    let promise = qcServices.getQCProductList(id, param);
    promise.then((res) => {
      if (res.data.success === true) {
        res?.data?.data?.products?.map((ele, i) => {
          ele._id = ele.productId;
          ele.inputQty = ele.qcQty;
        })
        setSelectedPOArr(res?.data?.data?.products);
        setSelectedDeletedArr(res?.data?.data?.products);
      } else {
        setAlertComponent({ open: true, type: "error", message: `No Data Found ` });
      }
    })
      .catch(function (error) {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };

  const onSortChange = (index, sortBy, sortOrder) => {
    let requestPayloadInit = _.cloneDeep(requestPayloadProduct);
    let columnsInit = _.cloneDeep(columns);
    let newSortLael = (sortOrder == "asc") ? "desc" : "asc";
    requestPayloadInit.sortArray = [sortBy, newSortLael];
    requestPayloadInit.pageNumber = 1;

    for (let i = 0; i < columnsInit.length; i++) {
      columnsInit[i].sortLabel = "";
      if (i == index) {
        columnsInit[i].sortLabel = newSortLael;
      }
    }

    setRequestPayloadProduct(requestPayloadInit);
    setColumns(columnsInit);
  }
  const onPaginationChange = (e, value) => {
    let requestPayloadInit = _.cloneDeep(requestPayloadProduct);
    requestPayloadInit.pageNumber = value;
    setRequestPayloadProduct(requestPayloadInit);
  }

  const onPageSizeChange = (e) => {
    let { value } = e.target;
    let requestPayloadInit = _.cloneDeep(requestPayloadProduct);
    requestPayloadInit.pageSize = value;
    requestPayloadInit.pageNumber = 1;
    setRequestPayloadProduct(requestPayloadInit);
  }

  const getPOProductsListing = (requestPayloadParam, filterTextParam, formData, selectedPOId) => {
    setIsLoading(true);
    let param = `?page=${requestPayloadParam?.pageNumber}&pageSize=${requestPayloadParam?.pageSize}&search=${filterTextParam}`;
    if (requestPayloadParam.sortArray.length > 0) {
      param += `&sortBy=${requestPayloadParam.sortArray[0]}&sortOrder=${requestPayloadParam.sortArray[1]}`;
    }
    // const filteredFormData = formData ? Object.entries(formData)
    //   .filter(([key, value]) => value !== '')
    //   .reduce((acc, [key, value]) => {
    //     acc[key] = value;
    //     return acc;
    //   }, {}) : {};
    // if (filteredFormData && Object.keys(filteredFormData).length > 0) {
    //   Object.entries(filteredFormData).forEach(([key, value]) => {
    //     param += `&${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
    //   });
    // }

    let promise = purchaseOrderServices.getPOProductsListing(selectedPO, param);
    promise.then((res) => {
      if (res.data.success === true) {
        setPOProductsListing(res?.data?.data);
      } else {
        setAlertComponent({ open: true, type: "error", message: `No Data Found ` });
        setPOProductsListing(productListInit);
      }
    })
      .catch(function (error) {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
        setPOProductsListing(productListInit);
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };

  const handleCheckboxInit = (e, data, index) => {
    const { checked } = e.target;
    const poProductsListingInit = _.cloneDeep(poProductsListing?.products);
    poProductsListingInit[index].isChecked = checked;
    setPOProductsListing((prevData) => ({ ...prevData, products: poProductsListingInit }));
  };

  const addRow = () => {
    let arr = [];
    const poProductsListingInit = _.cloneDeep(poProductsListing?.products);
    for (let i = 0; i < poProductsListingInit.length; i++) {
      let isValid = true;
      for (let j = 0; j < selectedPOArr.length; j++) {
        if (poProductsListingInit[i]?._id == selectedPOArr[j]?._id) {
          isValid = false;
        }
      }
      if (isValid && poProductsListingInit[i]?.isChecked) {
        arr.push(poProductsListingInit[i]);
      }
    }
    setSelectedPOArr((prevData) => ([...prevData, ...arr]));
  };

  const deleteRow = (i) => {
    let selectedPOArrInit = _.cloneDeep(selectedPOArr);
    const updatedRows = selectedPOArrInit.filter((row, idx) => i !== idx);
    setSelectedPOArr(updatedRows);
  };

  const onShipmentInputChange = (value, i) => {
    let selectedPOArrInit = _.cloneDeep(selectedPOArr);
    selectedPOArrInit[i]["inputQty"] = Number(value);
    // selectedPOArrInit[i]["totalValue"] = Number(value) * Number(selectedPOArrInit[i]["netPrice"]);
    setSelectedPOArr(selectedPOArrInit);
  };

  const onDetailsInputChange = (e) => {
    let { name, value } = e.target;
    setMdccDetails(prevData => ({ ...prevData, [name]: value }));
  };

  const uploadFile = (e, document, index) => {
    e.preventDefault();
    let formData = new FormData();
    let files = e.target.files[0]
    // const documentName = e.target?.dataset?.documentname;
    // const uniqueName = e.target?.dataset?.uniquename;
    formData.append("file", e.target.files[0]);
    setIsLoading(true);
    onboardingServices
      .uploadFile(formData)
      .then(function (response) {
        if (response?.data?.success === true) {
          setUrl(response?.data?.data, files, document, index);
        }
      })
      .catch(function (error) {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
        // openAlert(true, "error", `${error?.response?.data?.message}`);
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };
  const encodeKey = (key) => {
    if (!key) return key;
    return encodeURIComponent(key);
  };

  const setUrl = (data, files, document, index) => {

    let fileObj = {
      key: encodeKey(data?.data?.Key),
      fileName: files?.name
    };
    let mdccInit = _.cloneDeep(mdccDetails?.mdcc);
    mdccInit.push(fileObj);
    setMdccDetails(prevData => ({ ...prevData, ["mdcc"]: mdccInit }));
  };

  const closeMediaListModal = () => {
    setUploadFilesObj({});
    setIsMediaListModalOpen(false);
  };

  const onUploadMedia = (resData, uploadObj, files, data2) => {
    let obj = {
      key: encodeKey(resData?.data?.Key),
      fileName: files?.name,
    };
    uploadObj.response.push(obj); 
    setUploadFilesObj(uploadObj);
  };

  const openMediaModal = (document, index) => {
    setUploadFilesObj({ "response": mdccDetails?.mdcc });
    setIsMediaListModalOpen(true);
  }

  const dummyFun = () => {

  };

  const deleteFile = (index, key, idx) => {
    // console.log(mdccDetails, index, key, idx);
    
    const updatedFiles = uploadFilesObj.response.filter((file, i) => i !== index);
    const obj = { ...uploadFilesObj, response: [...updatedFiles] };
    setUploadFilesObj(obj);

    setMdccDetails(prevData => ({ ...prevData, ["mdcc"]: [...updatedFiles] }));
    // setIsMediaListModalOpen(false);

  };

  const submitQC = (index, key, idx) => {
    let arr = [];
    let isValid = true;
    if (selectedPOArr.length > 0) {
      for (let i = 0; i < selectedPOArr.length; i++) {
        if (isEmptyDash(selectedPOArr[i]?.inputQty)) {
          isValid = false;
        }
        arr.push({
          "productId": selectedPOArr[i]?._id,
          "qcQty": selectedPOArr[i]?.inputQty,
        });
      }
    } else {
      setAlertComponent({ open: true, type: 'error', message: `Please select atleast one product.`, });
      return;
    }

    let bodyData = {
      "purchaseOrderId": selectedPO,
      "products": arr,
      "mdccNumber": mdccDetails?.mdccNumber,
      "dateOfInspection": mdccDetails?.dateOfInspection,
      "mdccIssueDate": mdccDetails?.mdccIssueDate,
      "remarks": mdccDetails?.remarks,
      "mdcc": mdccDetails?.mdcc
    }
    for (let key in mdccDetails) {
      if (isEmptyDash(mdccDetails[key])) {
        isValid = false;
      }
    }
    if (isValid == false) {
      setAlertComponent({ open: true, type: 'error', message: 'Please enter all required fields.', });
      return;
    }

    
    setIsLoading(true);
    let promise = "";
    if (isEmptyDash(mdccDetails?.qcNumber)) {
      promise = qcServices.createQC(bodyData);
    } else {
      bodyData["productIdsToDelete"] = [];
      for (let i = 0; i < selectedDeletedArr.length; i++) {
        let isExist = false;
        for (let j = 0; j < selectedPOArr.length; j++) {
          if (selectedDeletedArr[i]?.productId == selectedPOArr[j]?._id) {
            isExist = true;
          }
        }
        if (isExist == false) {
          bodyData.productIdsToDelete.push(selectedDeletedArr[i]?.productId);
        }
      }
      promise = qcServices.updateQC(mdccDetails?._id, bodyData);
    }

    promise.then((res) => {
      if (res.data.success === true) {
        setAlertComponent({ open: true, type: 'success', message: `${res.data?.message}`, });
        if (isEmptyDash(mdccDetails?.qcNumber)) {
          navigateUrl(`/admin/vendor-qc-listing`);
        }
      } else {
        setAlertComponent({ open: true, type: 'error', message: 'Error!', });
      }
    })
      .catch((error) => {
        setAlertComponent({ open: true, type: 'error', message: `${error?.response?.data?.message}`, });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragging(false);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragging(false);
    const droppedFiles = Array.from(e.dataTransfer.files);
    setFiles(droppedFiles);
  };
  const handleFileInputChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    setFiles(selectedFiles);
  };

  const [checked, setChecked] = React.useState(true);

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };
  return (
    <>
      <div className="login-forms">
        <div className="text-centers">

          <div className="search_filter_outerse ms-auto">
            <div className="search_main">
              <h5>QC Creation Form</h5>
            </div>
          </div>
          <div id="second">
            <div className="psn_main_row_heading_lrcreation">
              <div>
                <p className="qccreationform_heading">
                  PO Detail
                </p>
              </div>
            </div>
            <div className="listing_main" style={{ overflowX: "scroll", overflowY: "scroll", marginTop: "10px" }}>
              <table>
                <thead>
                  <tr>
                    <th className="vendor_tabels">
                      {/* <input type="checkbox" /> */}
                    </th>
                    {columns.map((column, index) => (<>
                      <th className="vendor_tabels ">
                        <div className="PoDetailTableHeading">
                          <div className="d-flex">
                            <p>{column?.label}</p>
                            {(column.isSort == true) && <span onClick={(e) => onSortChange(index, column.id, column.sortLabel)} className="table-sort-ico">
                              {(column.sortLabel != "asc") && <img src={topArrow} />}
                              {(column.sortLabel == "asc") && <img src={topHighlightArrow} />}
                              {(column.sortLabel != "desc") && <img src={bottomArrow} />}
                              {(column.sortLabel == "desc") && <img src={bottomHighlightArrow} />}
                            </span>}
                          </div>
                        </div>
                      </th>
                    </>))}
                  </tr>
                </thead>
                <tbody>

                  {poProductsListing?.products.length < 1 && <>
                    <tr>
                      <td colSpan={8} className="text-center list-no-data">No Data Found</td>
                    </tr>
                  </>}
                  {poProductsListing?.products?.map((productData, i) => (<>
                    <tr className="maine_tr_vendor">
                      <td>
                        <input type="checkbox" onChange={(e) => handleCheckboxInit(e, productData, i)} checked={productData?.isChecked} />
                      </td>
                      {columns.map((column, j) => (column?.formate == "TEXT") ? <td>
                        {/* {productData[column?.id]} */}
                        <Tooltip title={productData[column.id] || "N/A"}>
                                  {productData[column.id] ? trimString(productData[column.id], 20) : "N/A"}
                                 </Tooltip>
                        </td> : (column?.formate == "RATE") ? 
                        <td>
                          {returnRateVal(productData[column?.id])}
                        </td> : (column?.formate == "DATE") ? 
                        <td>
                          {strToDate(productData[column?.id])}                    
                        </td> : null)}
                    </tr>
                  </>))}
                  {/* <tr className="maine_tr_vendor">
                      <td>
                        <input type="checkbox" />
                      </td>
                      <td className="block_solar">00701</td>
                      <td>Chinese masala</td>
                      <td>BGHHX01</td>
                      <td>200</td>
                      <td>700</td>
                      <td>100</td>
                      <td>100</td>
                      <td>₹ 35,600</td>
                      <td>₹ 35,600</td>
                    </tr> */}
                </tbody>
              </table>
            </div>

            {(poProductsListing?.products.length > 0) && <div className="lets_pagination_package_listing_vendor_button">
              <div className="pagination_select_react_packagelr_detail">
                <span className="react_text_showing">
                  Items per page:
                </span>
                <select
                  className="form-select packagelrlisting from-hs"
                  onChange={onPageSizeChange}
                  value={requestPayloadProduct?.pageSize}
                >
                  <option selected="10">10</option>
                  <option value="15">15</option>
                  <option value="20">20</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                </select>
                <span className="react_text_showing">
                  {` Showing rows ${Number(poProductsListing?.pageSize) * Number(poProductsListing?.currentPage - 1) + 1} to ${Number(poProductsListing?.pageSize) * Number(poProductsListing?.currentPage - 1) + Number(poProductsListing?.products?.length)} of ${poProductsListing?.totalItems}`}
                </span>
              </div>
              <Stack spacing={2}>
                <Pagination
                  count={poProductsListing?.totalPages}
                  page={poProductsListing?.currentPage}
                  onChange={(event, page) => {
                    setInputPage(page);
                    onPaginationChange(event, page);
                  }}
                  renderItem={(item) => {
                    if (item.page === poProductsListing?.currentPage) {
                      return (
                        <input
                          className="form-control"
                          type="text"
                          value={inputPage}
                          onChange={handleInputChange}
                          onKeyDown={handleInputSubmit}
                          style={{ width: "50px", marginLeft: "5px", marginRight: "5px", textAlign: "center" }}
                        />
                      );
                    }
                    return (
                      <PaginationItem
                        className="pagination_react_listings"
                        slots={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
                        {...item}
                      />
                    );
                  }}

                />
              </Stack>
            </div>}

            <div style={{ marginTop: "10px", marginBottom:"10px" }}>
              <button className="btn btn-primary btn-sm" onClick={addRow}>Add Item  </button>
            </div>

            <div className="search_filter_outers ms-auto">
              <div className="search_main">
                <div id="custom-search-input">
                  <div className="input-group col-md-12">
                    <input
                      type="text"
                      className="form-control input-lg"
                      placeholder="Search here"
                      fdprocessedid="8achb"
                    />
                    <span className="input-group-btn">
                      <button
                        className="btn btn-info btn-lg"
                        type="button"
                        fdprocessedid="trsp06"
                      >
                        <span className="glyphicon glyphicon-search">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-search"
                            viewBox="0 0 16 16"
                          >
                            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"></path>
                          </svg>
                        </span>
                      </button>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="search_mains">
              <p className="qccreationform_heading">QC Details</p>
            </div>
            <div className="listing_main" style={{ overflowX: "scroll" }}>
              <table>
                <thead>
                  <tr>
                    <th className="vendor_tabels">
                      {/* <input type="checkbox" /> */}
                    </th>
                    {columnshipment.map((column, index) => (<>
                      <th className="vendor_tabels ">
                        <div className="PoDetailTableHeading">
                          <div className="d-flex">
                            <p>{column?.label}</p>
                            {(column.isSort == true) && <span onClick={(e) => onSortChange(index, column.id, column.sortLabel)} className="table-sort-ico">
                              {(column.sortLabel != "asc") && <img src={topArrow} />}
                              {(column.sortLabel == "asc") && <img src={topHighlightArrow} />}
                              {(column.sortLabel != "desc") && <img src={bottomArrow} />}
                              {(column.sortLabel == "desc") && <img src={bottomHighlightArrow} />}
                            </span>}
                          </div>
                        </div>
                      </th>
                    </>))}
                  </tr>
                </thead>
                <tbody>

                  {selectedPOArr.length < 1 && <>
                    <tr>
                      <td colSpan={8} className="text-center list-no-data">No Data Found</td>
                    </tr>
                  </>}
                  {selectedPOArr?.map((productData, i) => (<>
                    <tr className="maine_tr_vendor">
                      <td>
                        <input type="checkbox" />
                      </td>
                      {columnshipment.map((column, j) => (column?.formate == "TEXT") ?
                        <td>
                          {/* {productData[column?.id]} */}
                          <Tooltip title={productData[column.id] || "N/A"}>
                                  {productData[column.id] ? trimString(productData[column.id], 20) : "N/A"}
                                 </Tooltip>
                        
                        </td> : (column?.formate == "INPUT_TEXT") ?
                          <td>
                               <Tooltip title={productData?.inputQty}>
                            <input type="number" className="form-control form-haswes" onChange={(e) => onShipmentInputChange(e.target.value, i)} 
                            // value={productData?.inputQty}
                            value={trimString(productData?.inputQty || "", 20)}
                            />
                            </Tooltip>
                          </td> : (column?.formate == "DELETE") ?
                            <td> <HighlightOffIcon className="highlight_close_btn" onClick={() => deleteRow(i)} /> </td> : (column?.formate == "RATE") ?
                              <td> ₹{isEmptyDash(productData[column?.id]) ? 0 : productData[column?.id]} </td> : (column?.formate == "DATE") ?
                                <td>{strToDate(productData[column?.id])}</td> : null)}
                    </tr>
                  </>))}
                  {/* <tr className="maine_tr_vendor">
                    <td>
                      <input type="checkbox" />
                    </td>
                    <td className="block_solar">00702</td>
                    <td>Chinese masala</td>
                    <td>230</td>
                    <td><input type="text" class="form-control form-ha" /></td>
                  </tr> */}
                </tbody>
              </table>
            </div>
            <div>
            </div>
            <div>
              <div className="search_filter">
                <div className="search_mains">
                  <p className="psn_shipment_main_heading">
                  </p>
                </div>
              </div>
              <div className="lets_asn_react_shipment_details_autos_vendor">
                <div className="lets_vendor_lr_details_block_asn">
                  <div className="required_react_vendor_block">
                    <label className="label_react_block_body_asn">
                      Date of Inspection :
                    </label>
                    <span className="required">*</span>
                    <div className="lets_asn_block_body_required_number">
                    <Tooltip title={mdccDetails?.dateOfInspection}>
                      <input type="date" className="form-control vendor_lr_inspection" name="dateOfInspection"
                      //  value={mdccDetails?.dateOfInspection}   
                      value={trimString(mdccDetails?.dateOfInspection || "", 20)}
                      onChange={onDetailsInputChange} />
                      </Tooltip>
                    </div>
                  </div>
                  <div className="required_react_vendor_block">
                    <label className="label_react_block_body_asn">
                      MDCC Number :
                    </label>
                    <span className="required">*</span>
                    <div className="lets_asn_block_body_required_number">
                    <Tooltip title={mdccDetails?.mdccNumber}>
                      <input type="text" className="form-control vendor_lr_inspection" name="mdccNumber"
                      //  value={mdccDetails?.mdccNumber}
                       value={trimString(mdccDetails?.mdccNumber || "", 20)} 
                       onChange={onDetailsInputChange} />
                      </Tooltip>
                    </div>
                  </div>
                  <div className="required_react_vendor_block">
                    <label className="label_react_block_body_asn">
                      MDCC Issue Date:
                    </label>
                    <span className="required">*</span>
                    <div className="lets_asn_block_body_required_number">
                    <Tooltip title={mdccDetails?.mdccIssueDate}>
                      <input type="date" className="form-control vendor_lr_inspection" name="mdccIssueDate"
                      //  value={mdccDetails?.mdccIssueDate}
                       value={trimString(mdccDetails?.mdccIssueDate || "", 20)}  
                      onChange={onDetailsInputChange} />
                      </Tooltip>
                    </div>
                  </div>
                </div>
                <div className="lets_vendor_lr_details_block_asn_react_body_block ">
                  <div className="required_react_vendor_block">
                    <label className="label_react_block_body_asn">
                      Remarks:
                    </label>
                    <span className="required">*</span>
                    <div className="lets_asn_block_body_required_number">
                    <Tooltip title={mdccDetails?.remarks}>
                      <textarea
                        type="text"
                        className="form-control vendor_origin_inspection"
                        name="remarks"
                        //  value={mdccDetails?.remarks} 
                         value={trimString(mdccDetails?.remarks || "", 70)} 
                         onChange={onDetailsInputChange}
                      />
                      </Tooltip>
                    </div>
                  </div>
                </div>
                <div className="special_instrustion_vendor_lr">
                  <div className="required_react_vendor_block">
                    <label className="label_react_block_body_asn">
                      MDCC:
                    </label>
                    <span className="required">*</span>
                    {/* {(isEmptyDash(mdccDetails?.mdcc)) && <div>
                     <input class="form-control form-hchoose teee" type="file" onChange={uploadFile} />
                    </div>} */}
                    {(!isEmptyDash(mdccDetails?.mdcc[0]?.key)) && <>
                      <div className="selected-file-present-div" style={{ display: 'inline', marginLeft: "10px" }}>{ }
                        <span className="selected-file-present-text">Document: {mdccDetails?.mdcc?.length} </span>
                      </div>
                      <button className="file-upload-btn"
                        onClick={() => openMediaModal(mdccDetails)}
                      >View</button>
                    </>
                    }

                    {(isEmptyDash(mdccDetails?.mdcc[0]?.key)) && <>
                      <div className="lets_block_package_listing_bom_file" style={isEmptyDash(mdccDetails?.mdcc[0]?.key) ? { display: 'block' } : { display: 'none' }}>
                        <div>
                          {/* <button className="upload_file_bom_tendor_project_react"
                                  // onClick={() => handleButtonClick(index)}
                                // htmlFor={`ref${index}`}
                                >
                                  <CloudUploadIcon className="download_icon_react" />
                                  Upload File
                                </button> */}
                          <input
                            type="file"
                            className="form-control form-hchoose teee"
                            // ref={(element) => fileInputRef.current[index] = element}
                            // id={`ref${index}`}
                            // style={{ display: "none" }}
                            onChange={(e) => uploadFile(e)}
                          />
                          {/* {selectedFile && <p>Selected file: {selectedFile.name}</p>} */}
                        </div>
                      </div>
                    </>}
                  </div>

                </div>
                <div>

                </div>
              </div>
            </div>
            <div className="submit_btn_forn_qccreation">
              <button
                type="button"
                class="btn cancel_btnform"
              >
                <Link
                  style={{ color: "white", textDecoration: "none" }}
                  to="/admin/vendor-qc-listing"
                >Cancel</Link>
              </button>
              <button
                type="button"
                class="btn btn-success save_next_btns"
                style={{ color: "white", textDecoration: "none" }}
                onClick={submitQC}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>

      <PackageDocuments
        isMediaListModalOpen={isMediaListModalOpen}
        closeMediaListModal={closeMediaListModal}
        uploadObj={uploadFilesObj}
        onUploadMedia={onUploadMedia}
        deleteFile={deleteFile}
        isSubmitCondition={false}
        onMediaActionChange={dummyFun}
        acceptAcknowledge={false}
        isColumn={{
          "DELETE": true,
          "INPUT_UPLOAD": true,
          // "INPUT_UPLOAD": getRFQDocPermission(uploadFilesObj)?.update,
          "STATUS": false,
          "VENDOR_DOC": false,
          "REMARKS": false,
        }}
      />

      <AlertComponent
        alertComponent={alertComponent}
        handleClose={handleCloseAlert}
      />

      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => 99999,
        }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  )
}

export default QcCreationForm